import React, { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, HashRouter, useLocation, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import AuthModal from "@/components/AuthModal";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderResult from "@/pages/OrderResult";

import Contact from "@/pages/Contact";
import Quiz from "@/pages/Quiz";
import Account from "@/pages/Account";




function AppContent() {
  const location = useLocation();
  const isLanding = location.pathname === "/";
  const lastRoute = useRef(null);
  useEffect(() => {
    const section = new URLSearchParams(location.search).get("section");
    const route = location.pathname + location.search;
    if (lastRoute.current === route) return;
    const initial = lastRoute.current === null;
    lastRoute.current = route;
    if (initial && !section) return;
    const sectionAliases = { products: "range", standard: "approach", reviews: "faq" };
    const resolvedSection = isLanding ? (sectionAliases[section] || section) : section;
    const allowed = ["range", "approach", "benefits", "quality", "compare", "story", "faq", "about", "careers", "signup", "egg-focus", "product-nutrition", "product-allergens", "product-use", "product-reviews"];
    const target = allowed.includes(resolvedSection) ? document.getElementById(resolvedSection) : document.querySelector("#main-content h1");
    if (target) {
      target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: "start", behavior: "auto" });
    }
  }, [location.pathname, location.search, isLanding]);
  return (
    <div className="App">
        <a className="skip-link" href="#main-content" onClick={event => { event.preventDefault(); document.getElementById("main-content")?.focus(); document.getElementById("main-content")?.scrollIntoView({ block: "start" }); }}>Skip to main content</a>


        <AuthProvider>
          <CartProvider>
            {!isLanding && <Navbar />}
            <CartDrawer />
            <AuthModal />
            <div id="main-content" tabIndex={-1}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/quiz" element={<Quiz />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<OrderResult />} />
                <Route path="/payment/cancel" element={<OrderResult cancelled />} />
                <Route path="/account" element={<Account />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </div>
            {!isLanding && <Footer />}
            <Toaster position="top-center" theme="dark"
              toastOptions={{ style: { background: "#30302B", border: "1px solid rgba(214,178,90,0.3)", color: "#F7F6F0" } }} />
          </CartProvider>
        </AuthProvider>

    </div>
  );
}

export default function App() {
  const Router = process.env.REACT_APP_DESIGN_PREVIEW === "true" ? HashRouter : BrowserRouter;
  return <Router><AppContent /></Router>;
}



